const mediaItems = [
  {
    title: '《长风渡》全集高清',
    tag: '热播剧集',
    desc: '白敬亭、宋轶领衔主演古装传奇大剧，全集已上线，高清画质畅快追。',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20costume%20drama%20cinematic%20scene%20with%20elegant%20hanfu%20characters%20in%20traditional%20courtyard%2C%20warm%20golden%20lighting%2C%20soft%20bokeh%20background%2C%20film%20grain%20texture%2C%20streaming%20platform%20thumbnail%20style&width=800&height=500&seq=bbtv-media-01&orientation=landscape',
    views: '1280万',
    eps: '40集全',
  },
  {
    title: '《流浪地球2》震撼上线',
    tag: '科幻巨制',
    desc: '吴京、刘德华主演国产科幻巅峰之作，4K超清画质，视觉盛宴不容错过。',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20scene%20with%20spaceship%20and%20stars%2C%20dramatic%20cinematic%20lighting%20with%20blue%20and%20warm%20orange%20contrast%2C%20epic%20scale%2C%20film%20poster%20aesthetic%2C%20streaming%20thumbnail%20style&width=800&height=500&seq=bbtv-media-02&orientation=landscape',
    views: '2150万',
    eps: '电影',
  },
  {
    title: '《庆余年第二季》热播中',
    tag: '权谋大剧',
    desc: '张若昀携原班人马回归，剧情持续高能，每日更新中，千万观众同步追剧。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20palace%20drama%20scene%20with%20intricate%20robes%20and%20traditional%20architecture%2C%20dramatic%20moody%20lighting%2C%20rich%20warm%20tones%2C%20cinematic%20composition%2C%20streaming%20thumbnail%20style&width=800&height=500&seq=bbtv-media-03&orientation=landscape',
    views: '3580万',
    eps: '更新至28集',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            精彩推荐
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-extrabold text-foreground-900">
            大家都在看
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            每日精选热门影视内容，高清流畅在线观看，免缓冲不卡顿
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {mediaItems.map((item, idx) => (
            <article
              key={idx}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading font-bold text-base md:text-lg text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                  {item.desc}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}次播放
                  </span>
                  <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 font-medium">
                    {item.eps}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}